import React, { useEffect } from 'react';
import {
  List,
  Datagrid,
  TextField,
  FunctionField
} from 'react-admin';

function SolucionEnergeticaList(props: any) {
  useEffect(() => {
    document.title = 'Listado de Soluciones Energéticas';
  }, []);

  return (
    <List {...props}>
      <Datagrid>
        <TextField source="id" />
        <FunctionField
          source="portada"
          render={(record: any) => (
            <img
              src={record.portada.url}
              alt={record.portada.alternativeText}
              style={{ width: '100px', height: 'auto' }}
            />
          )}
        />
        <TextField source="nombre" />
        <TextField source="externo" />
        <TextField source="url" />
      </Datagrid>
    </List>
  )
}

export default SolucionEnergeticaList